import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@aircall/ds";

import { EvaluationAccordionHeaderContent } from "@/components/EvaluationAccordionHeaderContent/EvaluationAccordionHeaderContent";
import { EvaluationCreateFormHeader } from "@/components/EvaluationCreateForm/components/EvaluationCreateFormHeader/EvaluationCreateFormHeader";
import { PlaygroundSectionLayout } from "../PlaygroundSectionLayout/PlaygroundSectionLayout";
import { PlaygroundSubSectionLayout } from "../PlaygroundSubSectionLayout/PlaygroundSubSectionLayout";
import { PlaygroundSubSectionTitle } from "../PlaygroundSubSectionTitle/PlaygroundSubSectionTitle";

const noop = () => {};

const CATEGORIES = ["Greetings", "Discovery", "Objection handling", "Empathy"];

export function PlaygroundReviewHeader() {
  return (
    <PlaygroundSectionLayout>
      <PlaygroundSubSectionLayout>
        <PlaygroundSubSectionTitle>
          Create-form header vs accordion item headers (hierarchy)
        </PlaygroundSubSectionTitle>
        <div className="w-[576px]">
          <EvaluationCreateFormHeader title="Sales Test Nico" onClose={noop} />
          <Accordion multiple>
            {CATEGORIES.map((category) => (
              <AccordionItem
                key={category}
                value={category}
                className="border-b border-border last:border-b-0"
              >
                <AccordionTrigger>
                  <EvaluationAccordionHeaderContent title={category} />
                </AccordionTrigger>
                <AccordionContent>
                  <div className="p-4 text-xs text-muted-foreground">
                    Questions for {category}
                  </div>
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </PlaygroundSubSectionLayout>
    </PlaygroundSectionLayout>
  );
}
